import axios from "axios";
import {Link} from 'react-router-dom';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function OpPackPay(){
    const [oppackData,setoppackData] = useState([]);
    const [amount, setAmount] = useState(0);
    const [balance, setBalance] = useState(0);
    const [mapData,setMapData] = useState([]);
    const {packid}=useParams();

    useEffect(() => {
        try{
            axios.get(baseUrl+'oppack-pay/'+packid)
            .then(function (response) {
                setoppackData(response.data);
                setAmount(response.data[0].pack_tot);
                setBalance(0);
            });
        }catch(error){
            console.log(error);
        }
    },[]);
    useEffect(() => {
  if (oppackData.length > 0) {
    const pid = oppackData[0]?.pack_price?.pack;
    const iid = oppackData[0]?.pack_price?.insur;

    axios.get(`${baseUrl}view-pack-map/${pid}/${iid}`)
      .then(response => {
        setMapData(response.data);
      })
      .catch(error => {
        console.log("Error fetching pack map:", error);
      });
  }
}, [oppackData]); // runs only after oppackData is populated
   const handleAmountChange = (event) => {
    let newAmount = parseInt(event.target.value, 10);
    const maxAmount = oppackData[0].pack_tot;
     if (newAmount > maxAmount) {
        newAmount = maxAmount;
    }
     setAmount(newAmount);
    setBalance(maxAmount - newAmount);
};


    const handlePaymentTypeChange = (event) => {
      const value = event.target.value;
      if (value === 'creditpay') {
        setAmount(0);
        setBalance(oppackData[0].pack_tot);
      } else {
        setAmount(oppackData[0].pack_tot);
        setBalance(0);
      }
    }

const handleFormSubmit = (e) => {
  e.preventDefault();

  const dbType = document.getElementById('dbType').value;
  const packid = oppackData[0]?.id;
  const amount = oppackData[0]?.pack_tot || 0;
  const balance = 0;

  const patId = oppackData[0]?.pat?.id || "";
  const consId = oppackData[0]?.cons?.id || "";

  // Step 1: Get Sale OP Pack invoice
  axios.post(`${baseUrl}get_sale_oppack/`)
    .then(response => {
      const sale_oppack = response.data.value;

      // Step 2: OP Pack Payment
      const _formDataPack = new FormData();
      _formDataPack.append('pack_paid', amount);
      _formDataPack.append('pack_balance', balance);
      _formDataPack.append('pack_invoice', sale_oppack);
      _formDataPack.append('pack_pmode', dbType);
      _formDataPack.append('cashier', userName);
      _formDataPack.append('pack_status', '2');
      _formDataPack.append('pack_price', oppackData[0]?.pack_price?.id);
      _formDataPack.append('addedby', oppackData[0]?.addedby);
      _formDataPack.append('ip_add', ipAddress);
      _formDataPack.append('location', userLocation);
      axios.post(`${baseUrl}oppack-payment/${packid}/`, _formDataPack, {
        headers: { 'content-type': 'multiple/form-data' }
      })
      .then(presponse => {
        if (presponse.status === 200 || presponse.status === 201) {

          // --- LAB BLOCK ---
          const lb = mapData.map(row => row.lab).filter(v => v != null);
          if (lb.length > 0) {
            axios.post(`${baseUrl}get_appt_lab_number/`)
              .then(response1 => {
                const appt_lab = response1.data.value;
                const _formDataLab = new FormData();
                const labTotal = mapData.reduce((total, row) => {
                  if (!row.labamount) return total;
                  const amounts = row.labamount.split(',').map(a => parseFloat(a.trim()));
                  return total + amounts.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
                }, 0).toFixed(2);

                _formDataLab.append('appt_id', appt_lab);
                _formDataLab.append('pat', patId);
                _formDataLab.append('cons', consId);
                _formDataLab.append('ltest_id', mapData.map(row => row.lab).filter(v => v != null));
                _formDataLab.append('lab_test', mapData.map(row => row.lab_test).filter(v => v != null));
                _formDataLab.append('lab_amount', mapData.map(row => row.labamount).filter(v => v != null));
                _formDataLab.append('lab_tot', labTotal);
                _formDataLab.append('lab_status', '1');
                _formDataLab.append('addedby', userName);
                _formDataLab.append('ip_add', ipAddress);
                _formDataLab.append('location', userLocation);

                // Create Lab entry
                axios.post(`${baseUrl}lab-create/`, _formDataLab)
                  .then(lresponse => {
                    const appt_id = lresponse.data.appt_id;

                    // Get Sale Lab invoice
                    axios.post(`${baseUrl}get_sale_lab/`)
                      .then(sresponse => {
                        const sale_lab = sresponse.data.value;
                        const _formDataLabPay = new FormData();
                        const labPaid = mapData.reduce((total, row) => {
                          if (!row.labamount) return total;
                          const amounts = row.labamount.split(',').map(a => parseFloat(a.trim()));
                          return total + amounts.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
                        }, 0).toFixed(2);

                        _formDataLabPay.append('lab_paid', labPaid);
                        _formDataLabPay.append('lab_balance', 0);
                        _formDataLabPay.append('lab_invoice', sale_lab);
                        _formDataLabPay.append('lab_pmode', dbType);
                        _formDataLabPay.append('cashier', userName);
                        _formDataLabPay.append('lab_status', '2');

                        // Pay Lab
                        axios.post(`${baseUrl}lab-payment/${appt_id}/`, _formDataLabPay, {
                          headers: { 'content-type': 'multiple/form-data' }
                        }).catch(console.log);
                      }).catch(console.log);
                  }).catch(console.log);
              }).catch(console.log);
          }

          // --- INVOICE BLOCK ---
          const iv = mapData.map(row => row.inv).filter(v => v != null);
          if (iv.length > 0) {
            axios.post(`${baseUrl}get_appt_inv_number/`)
              .then(iaresponse => {
                const appt_inv = iaresponse.data.value;
                const _formDataInv = new FormData();
                const invTotal = mapData.reduce((total, row) => {
                  if (!row.invamount) return total;
                  const amounts = row.invamount.split(',').map(a => parseFloat(a.trim()));
                  return total + amounts.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
                }, 0).toFixed(2);

                _formDataInv.append('appt_id', appt_inv);
                _formDataInv.append('pat', patId);
                _formDataInv.append('cons', consId);
                _formDataInv.append('itest_id', mapData.map(row => row.inv).filter(v => v != null));
                _formDataInv.append('inv_test', mapData.map(row => row.inv_test).filter(v => v != null));
                _formDataInv.append('inv_amount', mapData.map(row => row.invamount).filter(v => v != null));
                _formDataInv.append('inv_tot', invTotal);
                _formDataInv.append('inv_status', '1');
                _formDataInv.append('addedby', userName);
                _formDataInv.append('ip_add', ipAddress);
                _formDataInv.append('location', userLocation);

                // Create Invoice
                axios.post(`${baseUrl}inv-create/`, _formDataInv)
                  .then(iresponse => {
                    const appt_id = iresponse.data.appt_id;

                    axios.post(`${baseUrl}get_sale_inv/`)
                      .then(ivresponse => {
                        const sale_inv = ivresponse.data.value;
                        const _formDataInvPay = new FormData();
                        const invPaid = mapData.reduce((total, row) => {
                          if (!row.invamount) return total;
                          const amounts = row.invamount.split(',').map(a => parseFloat(a.trim()));
                          return total + amounts.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
                        }, 0).toFixed(2);

                        _formDataInvPay.append('inv_paid', invPaid);
                        _formDataInvPay.append('inv_balance', 0);
                        _formDataInvPay.append('inv_invoice', sale_inv);
                        _formDataInvPay.append('inv_pmode', dbType);
                        _formDataInvPay.append('cashier', userName);
                        _formDataInvPay.append('inv_status', '2');

                        axios.post(`${baseUrl}inv-payment/${appt_id}/`, _formDataInvPay, {
                          headers: { 'content-type': 'multiple/form-data' }
                        }).catch(console.log);
                      }).catch(console.log);
                  }).catch(console.log);
              }).catch(console.log);
          }

          // --- MINOR PROCEDURE BLOCK ---
          const mv = mapData.map(row => row.min).filter(v => v != null);
          if (mv.length > 0) {
            axios.post(`${baseUrl}get_appt_min_number/`)
              .then(miresponse => {
                const appt_min = miresponse.data.value;
                const _formDataMin = new FormData();
                const minTotal = mapData.reduce((total, row) => {
                  if (!row.minamount) return total;
                  const amounts = row.minamount.split(',').map(a => parseFloat(a.trim()));
                  return total + amounts.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
                }, 0).toFixed(2);

                _formDataMin.append('appt_id', appt_min);
                _formDataMin.append('pat', patId);
                _formDataMin.append('cons', consId);
                _formDataMin.append('min_id', mapData.map(row => row.min).filter(v => v != null));
                _formDataMin.append('min_test', mapData.map(row => row.min_test).filter(v => v != null));
                _formDataMin.append('min_amount', mapData.map(row => row.minamount).filter(v => v != null));
                _formDataMin.append('min_tot', minTotal);
                _formDataMin.append('min_status', '1');
                _formDataMin.append('addedby', userName);
                _formDataMin.append('ip_add', ipAddress);
                _formDataMin.append('location', userLocation);

                // Create Minor Procedure
                axios.post(`${baseUrl}min-create/`, _formDataMin)
                  .then(mresponse => {
                    const appt_id = mresponse.data.appt_id;

                    axios.post(`${baseUrl}get_sale_min/`)
                      .then(msresponse => {
                        const sale_min = msresponse.data.value;
                        const _formDataMinPay = new FormData();
                        const minPaid = mapData.reduce((total, row) => {
                          if (!row.minamount) return total;
                          const amounts = row.minamount.split(',').map(a => parseFloat(a.trim()));
                          return total + amounts.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
                        }, 0).toFixed(2);

                        _formDataMinPay.append('min_paid', minPaid);
                        _formDataMinPay.append('min_balance', 0);
                        _formDataMinPay.append('min_invoice', sale_min);
                        _formDataMinPay.append('min_pmode', dbType);
                        _formDataMinPay.append('cashier', userName);
                        _formDataMinPay.append('min_status', '2');

                        axios.post(`${baseUrl}min-payment/${appt_id}/`, _formDataMinPay, {
                          headers: { 'content-type': 'multiple/form-data' }
                        }).catch(console.log);
                      }).catch(console.log);
                  }).catch(console.log);
              }).catch(console.log);
          }

          Swal.fire({
            title: 'Payment Success and invoice is Generated',
            icon: 'success',
            timer: 5000,
            showConfirmButton: false
          });

          setTimeout(() => {
            window.location.href = (`/pack-invoice-op/${sale_oppack}/`);
          }, 3000);
        }
      }).catch(error => {
        console.log(error);
        Swal.fire('Error!', 'Failed to add oppack entry.', 'error');
      });
    }).catch(error => {
      console.log(error);
      Swal.fire('Error!', 'Failed to generate sale oppack invoice.', 'error');
    });
};

    return (
        <section className="container mt-4">
            <div className="row">
              <div className='col-md-9 col-12 mb-2'>
                <div className="row">
                    <h3 className="text-center"> OP Package Payment</h3>
                    <div className="table-responsive">
                    <table className="erp-table-modern">
                        <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                                <th>Pack Id</th>
                                <th>Patient Id</th>
                                <th>Patient Name</th>
                                <th>Addedby</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {oppackData.map((row,index) =>
                                <tr style={{border: "1px solid", borderColor: "#2194d9"}}>
                                    <td>{row.pack_price.id}</td>
                                    <td>{row.pat.pat_id}</td>
                                    <td>{row.pat.patient}</td>
                                    <td>{row.addedby}</td>
                                    <td>{row.pack_tot}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <form>
                        <label>Choose Payment Type</label>
                        <select name="dbType" id="dbType" onChange={handlePaymentTypeChange}>
                           <option value="cash">Cash</option>
                           <option value="card">Card</option>
                           <option value="creditpay">Credit Payment</option>
                           <option value="UPI">UPI</option>
                        </select>
                        <div className="form-group mt-3" >
                            <label style={{ fontWeight: 'bold' }}>Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" name="amount" id="amount" value={amount} onChange={handleAmountChange}  max={amount}/>
                            </div>
                        </div>
                        <div className="form-group mt-3" >
                            <label style={{ fontWeight: 'bold' }}>Balance Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" name="balance" id="balance" value={balance}
                                    onChange={handleAmountChange} readOnly />
                            </div>
                        </div>
                         <button type="button" onClick={handleFormSubmit} className="btn btn-primary mt-4">
                         Submit</button>
                   </form>
              </div>
            </div>
            </div>
            </div>
        </section>

)
}

export default OpPackPay;